var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.5 9C4.2525 9 4.04062 8.91187 3.86437 8.73562C3.68812 8.55937 3.6 8.3475 3.6 8.1V2.1C3.6 1.8525 3.68812 1.64063 3.86437 1.46438C4.04062 1.28813 4.2525 1.2 4.5 1.2H9.3C9.5475 1.2 9.75937 1.28813 9.93562 1.46438C10.1119 1.64063 10.2 1.8525 10.2 2.1V8.1C10.2 8.3475 10.1119 8.55937 9.93562 8.73562C9.75937 8.91187 9.5475 9 9.3 9H4.5ZM4.5 8.1H9.3V2.1H4.5V8.1ZM2.7 10.8C2.4525 10.8 2.24062 10.7119 2.06437 10.5356C1.88812 10.3594 1.8 10.1475 1.8 9.9V3H2.7V9.9H8.4V10.8H2.7Z",
    fill: "#5E6E87"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.f3f65782b61a47dbcfcfe556246daccc.svg";
export { ForwardRef as ReactComponent };